import { useState } from "react";
import useFieldState from "../../../hooks/useFieldState";
import useForm from "../../../hooks/useForm";
import { useWizard } from "../../../hooks/useWizard";
import { DropdownInput } from "../../Form/DropdownInput";
import { RadioInput } from "../../Form/RadioInput";
import {
  ModalContentContainer,
  ModalBody,
  ModalSection,
  ModalFooter,
} from "../../Modal/index";
import { ElementContainer } from "../../Form/ElementContainer";

export const RegionSelector = () => {
  const { register, setValue } = useForm();
  const [{ query_layers, areas }] = useFieldState();
  const { step, setFormValues, error } = useWizard();
  const [isChecked, setChecked] = useState("zone");

  return (
    <ModalContentContainer>
      <ModalBody
        title="Which region would you like to view?"
        customStyle="sm:w-4/5"
      >
        <ModalSection styles="h-full">
          <p className="text-sm sm:text-base py-3">
            You can select either one zone and agglomeration (zone) or one Local
            Authority.
          </p>
          <p className="text-sm sm:text-base pb-3">
            Zones are areas of land defined specifically for air quality
            compliance reporting purposes <a
              className="text-blue-600 underline"
              href="https://uk-air.defra.gov.uk/air-pollution"
            >
              here
            </a>
            , there are 43 to choose from.
          </p>
          <p className="text-sm sm:text-base pb-2">
            Local Authorities are the governing body of a county or district,
            the number of Local Authorities may vary between years.
          </p>
        </ModalSection>
        <ModalSection styles="flex content-center flex-wrap">
          <ElementContainer
            styles={{ container: "", label: "text-base sm:text-3xl font-bold" }}
            label="Select the region"
          >
            {query_layers.map((value, index) => (
              <RadioInput
                defaultChecked={index === 0}
                id={value.id}
                isChecked={isChecked}
                key={value.id}
                label={value.name}
                labelPosition={1}
                name={"query_layer"}
                ref={register}
                setChecked={(value) => setChecked(value)}
                setValue={setValue}
                styles={{
                  container: "flex items-center pl-4",
                  input:
                    "w-6 h-6 text-dark-blue border-2 border-gray-400 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
                  label:
                    "py-4 ml-2 w-full text-sm sm:text-lg font-bold text-gray-900 dark:text-gray-300",
                }}
              />
            ))}
          </ElementContainer>
        </ModalSection>
        <ModalSection styles="flex content-center flex-wrap">
          <DropdownInput
            displayError={error}
            errorMessage="Please select the area."
            label="Select the area"
            name="zone_la_list"
            options={areas[isChecked]?.map((a) => ({
              value: a.id,
              label: a.name,
            }))}
            ref={register}
            styles={{
              container: "w-full ",
              label: "text-base sm:text-3xl font-bold",
              dropdown: "mt-2 max-w-xs",
              error: "text-red-600 font-xs h-5"
            }}
            setValue={setValue}
            componentStateHoldValue={step === 3 ? setFormValues : undefined}
          />
        </ModalSection>
      </ModalBody>
      <ModalFooter currentFormValue="zone_la_list" />
    </ModalContentContainer>
  );
};
